import {svgIconWrapper} from '../svg-icon-wrapper';

import GlobeRegularSearch from './globe-regular-search-icon.svg';

function SvgComponent(props: React.SVGProps<SVGSVGElement>) {
    return <GlobeRegularSearch {...props} />;
}
SvgComponent.iconName = 'globeRegularSearch';

export const GlobeRegularSearchIcon = svgIconWrapper(SvgComponent);
